export default __webpack_public_path__ + "static/media/lend-ooki.20d290bb.svg";